import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status-formed",
  "use": "status-formed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"status-formed\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.111 8.444v4.445l3.778 2.24.684-1.138-3.129-1.858V8.444h-1.333zM20 10.222V4l-2.347 2.347A7.944 7.944 0 0 0 12 4a8 8 0 1 0 8 8h-1.778A6.23 6.23 0 0 1 12 18.222 6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778c1.716 0 3.271.702 4.4 1.822l-2.622 2.622H20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol